exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.loading-text {\n    background: black;\n    padding: 3px 5px;\n    border-radius: 6px;\n    text-align: center;\n    color: #E8E0CC;\n    font-size: 10px;\n    position: absolute;\n    bottom: 10px;\n}\n", ""]);

// exports
